import { Outlet, useLocation } from 'react-router';
import clsx from 'clsx';
import { LeftMenu, Header, Footer } from '@/components';
import '@/assets/styles/components/main-layout.scss';
import { HideLeftMenuPaths, NavigationPath } from '@/router/navigation-path.ts';

const FIT_VIEWPORT_PATHS: string[] = [NavigationPath.boutiqueClassroom];
const BOUTIQUE_SURFACE_PATHS: string[] = [NavigationPath.boutiqueClassroom];

const MainLayout = () => {
	const location = useLocation();
	const hideLeftMenu = HideLeftMenuPaths[location.pathname as keyof typeof HideLeftMenuPaths];
	const isFitViewportRoute = FIT_VIEWPORT_PATHS.some(path => location.pathname.startsWith(path));
	const isBoutiqueSurfaceRoute = BOUTIQUE_SURFACE_PATHS.some(path => location.pathname.startsWith(path));

	return (
		<>
			<div className={clsx('main-content-container', { 'main-content-container--boutique': isBoutiqueSurfaceRoute })}>
				<Header />
				<div className={clsx('main-layout', { 'main-layout--fit-viewport': isFitViewportRoute })}>
					{!hideLeftMenu && <LeftMenu />}
					<Outlet />
				</div>
				<Footer />
			</div>
		</>
	);
};

export default MainLayout;
